module.exports = __webpack_public_path__ + "img/animals_poodle.9ff0146b.png";